/*
  Единая точка импорта иконок.

  Сами контуры лежат в icons.design.tsx и сгенерированы из выгрузки
  библиотеки макета (`python tools/design_icons.py`). Рисовать иконки
  «похоже» нельзя: неузнанный логотип монеты — это перевод LTC на
  BTC-адрес, а такой перевод не возвращается.

  Здесь только псевдонимы под имена, уже разошедшиеся по коду, и
  прежние размеры по умолчанию: часть иконок в интерфейсе стоит 20px,
  и если молча отдать им 24px, поедут высоты полей и кнопок.
*/
import {
  ChevronDownIcon, ChevronRightIcon, ShieldIcon,
  CopyIcon as Copy24, CheckIcon as Check24, QrIcon as Qr24,
  EyeIcon as Eye24, EyeOffIcon as EyeOff24, PlusIcon as Plus24,
  TrashIcon as Trash24, EditIcon as Edit24, MailIcon as Mail24,
  LockIcon as Lock24, UserIcon as User24, SearchIcon as Search24,
} from './icons.design'

export {
  BtcIcon, LtcIcon, GramIcon, XmrIcon, UsdtIcon,
  ClockIcon, InfoIcon, MoonIcon, SunIcon, TelegramIcon, CloseIcon,
  SettingsIcon, ShieldIcon, ExitIcon, WarningIcon, SquareIcon,
  MenuIcon, HistoryIcon, DepositIcon, WithdrawIcon,
  ChevronUpIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon,
} from './icons.design'

interface Props { size?: number }

/* Прежние 20px по умолчанию. */
export const CopyIcon = ({ size = 20 }: Props) => Copy24({ size })
export const CheckIcon = ({ size = 20 }: Props) => Check24({ size })
export const QrIcon = ({ size = 20 }: Props) => Qr24({ size })
export const EyeIcon = ({ size = 20 }: Props) => Eye24({ size })
export const EyeOffIcon = ({ size = 20 }: Props) => EyeOff24({ size })
export const PlusIcon = ({ size = 20 }: Props) => Plus24({ size })
export const TrashIcon = ({ size = 20 }: Props) => Trash24({ size })
export const EditIcon = ({ size = 20 }: Props) => Edit24({ size })
export const MailIcon = ({ size = 20 }: Props) => Mail24({ size })
export const LockIcon = ({ size = 20 }: Props) => Lock24({ size })
export const UserIcon = ({ size = 20 }: Props) => User24({ size })
export const SearchIcon = ({ size = 20 }: Props) => Search24({ size })

/* Псевдонимы под уже разошедшиеся по коду имена. */
export const ChevronIcon = ChevronDownIcon
export const ArrowRightIcon = ChevronRightIcon
/** Поле кода 2FA. В библиотеке макета ключа нет, ближайшее по смыслу — щит. */
export const KeyIcon = ({ size = 20 }: Props) => ShieldIcon({ size })
